import { render, staticRenderFns } from "./NewClassroomObservation.vue?vue&type=template&id=5e5813a6&scoped=true"
import script from "./NewClassroomObservation.vue?vue&type=script&lang=js"
export * from "./NewClassroomObservation.vue?vue&type=script&lang=js"
import style0 from "./NewClassroomObservation.vue?vue&type=style&index=0&id=5e5813a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5813a6",
  null
  
)

export default component.exports